import React from 'react';
import Modal from 'react-modal';
import './styles.css';

const HafaSambandAlert = ({ isOpen, onClose }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Alert"
            className="custom-modal"
            overlayClassName="custom-overlay"
        >
            <div className="alert-container">
                <h2 className="alert-title">Takk fyrir að senda í gegnum vefsíðuna okkar!</h2>
                <p className="alert-message">Við munum hafa samband innan skamms í tölvupósti.</p>
                <button onClick={onClose} className="alert-button">Loka</button>
            </div>
        </Modal>
    );
};

export default HafaSambandAlert;